import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../utils/Methods";
import { IDS } from "../../utils/IDS";

export const SubmitDepositQuery = createAsyncThunk(
    "support/SubmitDepositQuery/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.Deposit, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const SubmitWithdrawQuery = createAsyncThunk(
    "support/SubmitWithdrawQuery/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.Withdraw, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const SubmitIFSCModification = createAsyncThunk(
    "support/SubmitIFSCModification/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.IFSC, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const SubmitChangePassword = createAsyncThunk(
    "support/SubmitChangePassword/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.ChangePassword, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const SubmitChangeBankName = createAsyncThunk(
    "support/SubmitChangeBankName/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.ChangeBankName, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const SubmitModifyBankInformation = createAsyncThunk(
    "support/SubmitModifyBankInformation/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.ModifyBankInfo, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const SubmitModifyUPI = createAsyncThunk(
    "support/SubmitModifyUPI/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.ModifyUpi, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const SubmitAddUSDTAddress = createAsyncThunk(
    "support/SubmitAddUSDTAddress/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.AddUSDTAddress, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const SubmitChangeUSDTAddress = createAsyncThunk(
    "support/SubmitChangeUSDTAddress/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.ChangeUSDTAddress, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const SubmitActivityBonus = createAsyncThunk(
    "support/SubmitActivityBonus/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.ActivityBonus, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const GetAllProgessQuery = createAsyncThunk(
    "support/GetAllProgessQuery/get-all",
    async (filter, { rejectWithValue }) => {

        try {
            const res = await GET(`${APIS.Support.Support}?name=${filter?.name || ""}&status=${filter?.status || ""}&support_type_id=${filter?.type || ""}&start_date=${filter?.startDate || ""}&end_date=${filter?.endDate || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const SubmitQueryReminder = createAsyncThunk(
    "support/SubmitQueryReminder/post",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Support.Reminder, data);
            if (res.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);


// Get Single
export const GetSingle = createAsyncThunk(
    "masters/support/get",
    async ({ id, type }, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.Support.Support}/get-single/${id}?type=${type}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


//  WithdrawStatusChange
export const WithdrawStatusChange = createAsyncThunk(
    "masters/support/WithdrawstatusChange",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Support.WithdrawReq}/${id}`, data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

//  Delete
export const Delete = createAsyncThunk(
    "masters/support/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${APIS.Masters.Support}/${id}`);
            return id; // Return the id of the deleted country
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



export const Slice = createSlice({
    name: "support",
    initialState: {
        data: [],

        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder


            .addCase(GetAllProgessQuery.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllProgessQuery.fulfilled, (state, action) => {

                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data || [];
                // state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                // state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                // state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                // state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAllProgessQuery.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })



            .addCase(GetSingle.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingle.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(GetSingle.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })


            .addCase(WithdrawStatusChange.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(WithdrawStatusChange.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                const index = state.data.findIndex(
                    (support) => support.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(WithdrawStatusChange.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (support) => support.id !== action.payload.id
                );
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { SetSelectedBank, ClearSelectedBank } = Slice.actions;

export default Slice.reducer;
